import { useState } from "react";
import { X, MessageCircle, Lock } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Price, inputCls, useCountdown } from "./parts";

const MiniGuide = () => (
  <div className="h-[62px] w-[48px] shrink-0 rounded-[4px_8px_8px_4px] bg-gradient-to-br from-[#17486A] to-[#0B1F2E] shadow-[3px_0_0_#E1E8EC,8px_10px_18px_-6px_rgba(16,43,63,.5)] flex flex-col justify-end p-1.5" aria-hidden>
    <div className="lp-150 font-display font-extrabold leading-none" style={{ fontSize: 20 }}>150</div>
    <div className="h-[2px] w-4 bg-[#0BAF9A] rounded-full mt-1" />
  </div>
);

export function LeadPopup({ open, onDismiss, onSubmit, offer, t, cfg }) {
  const [f, setF] = useState({ first_name: "", whatsapp: "" });
  const submit = (e) => {
    e.preventDefault();
    if (!f.first_name.trim() || f.whatsapp.replace(/\D/g, "").length < 7) { toast.error(t.modal.invalid); return; }
    onSubmit(f);
  };
  const cd = useCountdown(offer?.promo_active ? offer.promo_expiry : null);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onDismiss()}>
      <DialogContent className="w-[90vw] max-w-[380px] rounded-3xl bg-white p-5 gap-3 max-h-[85dvh] overflow-y-auto shadow-[0_24px_60px_-20px_rgba(16,43,63,.45)] [&>button:last-child]:hidden" data-testid="lead-popup">
        <button onClick={onDismiss} className="absolute right-3 top-3 h-9 w-9 rounded-full bg-[#F1F5F7] hover:bg-[#E1ECEF] flex items-center justify-center text-[#102B3F]" aria-label="Close" data-testid="lead-popup-close"><X className="h-4 w-4" /></button>
        <div className="flex gap-3.5 items-center pr-9">
          <MiniGuide />
          <DialogTitle className="font-display font-extrabold text-[19px] leading-tight text-[#102B3F]" data-testid="lead-popup-headline">{cfg.headline}</DialogTitle>
        </div>
        <DialogDescription className="text-[14px] text-[#4A5D6A] leading-snug" data-testid="lead-popup-text">{cfg.text}</DialogDescription>
        <div className="flex items-center justify-between rounded-2xl bg-[#EAF8F4] px-4 py-2.5">
          <span className="text-xs font-semibold text-[#5C6B73]">{t.popup.price}</span>
          <Price offer={offer} t={t} size="sm" testid="lead-popup-price" showExpiry={false} />
        </div>
        {cd && <div className="-mt-1.5 text-center text-[12px] font-bold text-[#DC2626] tabular-nums" data-testid="lead-popup-countdown">{t.price.ends} {cd}</div>}
        <form onSubmit={submit} className="space-y-2.5">
          <input required autoComplete="given-name" placeholder={t.modal.name} value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} className={inputCls} data-testid="lead-popup-name-input" />
          <input required type="tel" inputMode="tel" autoComplete="tel" placeholder={t.modal.phone} value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} className={inputCls} data-testid="lead-popup-whatsapp-input" />
          <button className="lp-btn w-full min-h-[50px] text-[15px] px-4" data-testid="lead-popup-submit-btn"><MessageCircle className="h-4 w-4 shrink-0" />{cfg.button}</button>
          <p className="text-[11px] text-[#5C6B73] text-center" data-testid="lead-popup-nopay">{t.popup.noPay}</p>
        </form>
        <p className="text-[10.5px] text-[#7D8C96] flex gap-1.5 leading-snug"><Lock className="h-3 w-3 mt-0.5 shrink-0" />{t.popup.privacy}</p>
        <button onClick={onDismiss} className="text-sm font-semibold text-[#5C6B73] hover:text-[#102B3F] h-9" data-testid="lead-popup-later-btn">{t.popup.later}</button>
      </DialogContent>
    </Dialog>
  );
}
